import { useState, useEffect } from 'react';

const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight > 0) {
        setProgress(Math.min((scrollTop / docHeight) * 100, 100));
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className="fixed top-0 left-0 w-full z-[100]"
      style={{ height: '3px', backgroundColor: 'rgba(10,15,26,0.05)' }}
      data-testid="reading-progress-bar"
    >
      <div
        style={{
          height: '100%',
          width: `${progress}%`,
          backgroundColor: '#FF5722',
          transition: 'width 0.1s linear',
        }}
      />
    </div>
  );
};

export default ReadingProgress;
